import React from 'react';
import ContentLoader from 'react-content-loader';
import PanelContainer from './../PanelContainer';

const FirmReviewsContentLoader = props => (
  <PanelContainer
    styles={{
      height: '370px',
      padding: '30px',
    }}
  >
    <ContentLoader
      height={260}
      width={825}
      speed={2}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      <rect x="0" y="63" rx="3" ry="3" width="189" height="20" />
      <rect x="0" y="20" rx="3" ry="3" width="122" height="20" />
      <rect x="104" y="134" rx="3" ry="3" width="121" height="20" />
      <circle cx="43" cy="159" r="42" />
      <rect x="104" y="164" rx="3" ry="3" width="90" height="20" />
      <circle cx="354" cy="159" r="42" />
      <rect x="414" y="134" rx="3" ry="3" width="121" height="20" />
      <rect x="414" y="164" rx="3" ry="3" width="90" height="20" />
      <rect x="598" y="144" rx="3" ry="3" width="180" height="34" />
    </ContentLoader>
  </PanelContainer>
);

export default FirmReviewsContentLoader;
